import axios from "axios";
import config from "../config";

const apiURL = config("API_URL");
const getTrendingEvents = async locale => {
  const response = await axios.get(`${apiURL}/trending/`, {
    params: { locale }
  });
  return response.data;
};

export default { getTrendingEvents };
